const SESSION_THRESHOLDS = [
  500, 450, 400, 350, 300, 250, 200, 150, 100, 50, 10,
] as const;

export function roundToThreshold(count: number): number {
  for (const t of SESSION_THRESHOLDS) {
    if (count >= t) return t;
  }
  return 10;
}

export const yearsToString = (years: number) => {
  if (years === 1) {
    return "godinu";
  }

  if (years > 1 && years < 5) {
    return "godine";
  }

  return "godina";
};
